import { Link } from "react-router-dom";

/** Placeholder: the shop itself has not been specified yet. */
export function Store() {
  return (
    <div className="splitter">
      <h1 className="wordmark big">Store</h1>
      <p className="notice centered">The shop is not open yet.</p>
      <Link className="back" to="/">
        ← Back
      </Link>
    </div>
  );
}
